import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["value"]

  connect() {
    this.finalValues = new Map(
      this.valueTargets.map((element) => [element, element.textContent.trim()])
    )
    this.animationFrames = []

    if (this.element.dataset.numberAnimationComplete === "true" || this.prefersReducedMotion()) return

    this.element.dataset.numberAnimationComplete = "true"
    this.valueTargets.forEach((element) => this.animate(element))
  }

  disconnect() {
    this.animationFrames.forEach((frame) => cancelAnimationFrame(frame))
    this.finalValues.forEach((value, element) => { element.textContent = value })
  }

  animate(element) {
    const finalValue = this.finalValues.get(element)
    const parts = finalValue.match(/^([^\d-]*)(-?[\d,]+)(.*)$/)
    if (!parts) return

    const target = Number.parseInt(parts[2].replace(/,/g, ""), 10)
    const usesGrouping = parts[2].includes(",")
    const startedAt = performance.now()
    const frameIndex = this.animationFrames.length

    const update = (now) => {
      const progress = Math.min((now - startedAt) / 1500, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      const value = Math.floor(eased * target)
      const number = usesGrouping ? value.toLocaleString("en-US") : value.toString()
      element.textContent = `${parts[1]}${number}${parts[3]}`

      if (progress < 1) {
        this.animationFrames[frameIndex] = requestAnimationFrame(update)
      } else {
        element.textContent = finalValue
      }
    }

    this.animationFrames[frameIndex] = requestAnimationFrame(update)
  }

  prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
